import React from 'react';
import { useParams } from 'react-router-dom';
import EventsList from './EventsList';
import EventEditor from './EventEditor';

export default function EventsPage() {
  const { id } = useParams();
  return id ? <EventEditor eventId={id} /> : <EventsList />;
}
